import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  employeeData = new BehaviorSubject({});

  constructor() { }

  public setEmployeeData(data: object): void {
    if (!data) {
      return;
    }
    this.employeeData.next(data);
  }

}
